export default "<span *ngIf=\"count || count===0\">{{ count }}<i class=\"fa fa-{{ icon }}\"></i></span>";